// REACT AND REACT HOOKS
import React, { useState, useEffect, useRef } from 'react';

// BOOTSTRAP COMPONENTS for modal and buttons
import { Modal, Button } from 'react-bootstrap';

// DATATABLES LIBRARY (not used directly here, but imported for consistency)
import DataTable from 'datatables.net-react';

// UTILITY FUNCTIONS for extracting plain item names
import { getPlainName } from '../FP_foodPantryUtils';

// TABLE COLUMN CONFIGURATIONS (not used directly here, but available for future table displays)
import { columnsInventory, columnsTransactions } from '../FP_foodPantryTables';

// Modal for logging other types of inventory transactions (damage, transfer, etc.)
export function OtherTransactionsModal({
  show, // Boolean to show/hide modal
  onHide, // Function to close modal
  newItemDetails, // State object for form fields
  handleInputChange, // Generic input change handler
  handleAddNewItem // Handler to add new transaction to inventory
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="create new other transaction"
      centered
    >
      <div className="text-dark">
        {/* Modal header with close button and title */}
        <Modal.Header closeButton className="mx-2">
          <Modal.Title id="newInventoryItem">Other Transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Form for entering details of the other transaction */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // Parse price and quantity as numbers for calculations
              const price = parseFloat(newItemDetails.price || 0);
              const quantity = parseInt(newItemDetails.quantity || 0);
              // Compose new item object for transaction
              const newItem = {
                ...newItemDetails,
                itemName: newItemDetails.itemName,
                unitQty: newItemDetails.unit,
                packSize: newItemDetails.pack,
                itemID: newItemDetails.item_id,
                qoh: quantity,
                suggestedPrice: price,
                value: price * quantity,
              };
              // Add new transaction to inventory and close modal
              handleAddNewItem(newItem);
            }}
          >
            {/* Dropdown for selecting transaction reason */}
            <select
              className="form-select mb-1"
              name="reason"
              value={newItemDetails.reason || ""}
              onChange={handleInputChange}
              required
            >
              <option value="" disabled hidden>Select reason</option>
              <option value="Open package">Open package</option>
              <option value="Item damage">Item damage</option>
              <option value="Out of Date">Out of Date</option>
              <option value="Damage in Transit">Damage in Transit</option>
              <option value="Food Pantry Transfer">Food Pantry Transfer</option>
            </select>

            {/* Row for item name, unit quantity, and pack size */}
            <div className="row g-2">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Item Name"
                  className="mb-1 form-control"
                  name="name"
                  value={newItemDetails.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  placeholder="Unit Qty"
                  className="mb-1 form-control"
                  name="unit"
                  value={newItemDetails.unit}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  placeholder="Pack Size"
                  className="mb-1 form-control"
                  name="pack"
                  value={newItemDetails.pack}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Row for category, price, and quantity */}
            <div className="row g-2">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Category"
                  className="my-1 form-control"
                  name="category"
                  value={newItemDetails.category}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <input
                  type="number"
                  step="0.01"
                  placeholder="Item Price"
                  className="my-1 form-control"
                  name="price"
                  value={newItemDetails.price}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <input
                  type="number"
                  placeholder="Quantity"
                  className="my-1 form-control"
                  name="quantity"
                  value={newItemDetails.quantity}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            {/* Row for item ID (for debugging or tracking) */}
            <div className="row g-2">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Item ID (debugging)"
                  className="my-1 form-control"
                  name="item_id"
                  value={newItemDetails.item_id}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Submit button for the transaction */}
            <div className="d-flex justify-content-end my-1 gap-2">
              <Button type="submit" variant="primary">Submit</Button>
            </div>
          </form>
        </Modal.Body>
      </div>
    </Modal>
  );
}
